import { inject, Injectable } from "@angular/core";
import { lastValueFrom, forkJoin, iif, defer, of, switchMap, map } from "rxjs";
import { InstallationBackend } from "src/app/backend/api/installation.backend";
import { Connection } from "src/app/backend/models/connection";
import {
  ConnectIntegrationConnectionResult,
  ConnectIntegrationConnectionResultType,
  ConnectIntegrationConnector,
  ConnectIntegrationInfo
} from "src/app/modules/bootstrap/functions/integrations/connect-integration/connect-integration.connector";

@Injectable()
export class ConnectIntegrationNoneConnector implements ConnectIntegrationConnector {
  readonly #installationBackend = inject(InstallationBackend);

  connect({
    integration,
    installation,
    isRefresh,
    refreshConnectionId,
    phase
  }: ConnectIntegrationInfo): Promise<ConnectIntegrationConnectionResult> {
    return new Promise<ConnectIntegrationConnectionResult>(async (resolve) => {
      const connection = await lastValueFrom(
        forkJoin({
          createdConnetion: iif(
            () => !isRefresh,
            defer(() => {
              return this.#installationBackend.createConnection({
                provider: integration.provider,
                type: "none",
                default: phase === "install",
                installationId: installation.id
              });
            }),
            of(undefined)
          ),
          updatedConnection: iif(
            () => !!isRefresh,
            defer(() => {
              return this.#installationBackend
                .loadConnectionById(refreshConnectionId!)
                .pipe(
                  switchMap((connection: Connection) => {
                    return this.#installationBackend
                      .updateConnectionCredentials({
                        connectionId: refreshConnectionId!,
                        version: connection.version,
                        type: "none",
                        credentials: undefined
                      })
                      .pipe(
                        switchMap(() =>
                          this.#installationBackend.loadConnectionById(
                            refreshConnectionId!
                          )
                        )
                      );
                  })
                );
            }),
            of(undefined)
          )
        }).pipe(
          map(({ createdConnetion, updatedConnection }) => {
            return updatedConnection || createdConnetion;
          })
        )
      );

      resolve({
        result: ConnectIntegrationConnectionResultType.SUCCEED,
        connection
      });
      resolve({ result: ConnectIntegrationConnectionResultType.SUCCEED });
    });
  }
}
